import { ejecutarExpresion } from '../motor/ejecutarExpresion.js'

function escaparXmlTexto(valor) {
  return String(valor)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

function extraerPlaceholder(xml, startIndex) {
  const n = xml.length
  let j = startIndex + 2
  let depth = 1

  while (j < n && depth > 0) {
    const c = xml[j]
    if (c === '{') depth++
    else if (c === '}') depth--
    j++
  }

  if (depth !== 0) return null
  const tag = xml.slice(startIndex, j)
  const contenido = tag.replace(/^\$\{|\}$/g, '')
  return { tag, contenido, endIndex: j }
}

function evaluarPlaceholder(contenido, datos, errors, runtimeContext, tag) {
  const erroresEvaluacion = []
  const valor = ejecutarExpresion(contenido, datos, erroresEvaluacion, runtimeContext)

  if (erroresEvaluacion.length) {
    errors.push(
      ...erroresEvaluacion.map((error) => ({
        ...error,
        detail: {
          ...(error?.detail && typeof error.detail === 'object' ? error.detail : {}),
          tag,
        },
      }))
    )
    return { ok: false }
  }

  return { ok: true, value: valor }
}

function consumirPlaceholderOriginal(runtimeContext, normalizado) {
  const originales = runtimeContext?.placeholdersOriginales?.get(normalizado)
  return originales?.length ? originales.shift() : normalizado
}

export function reemplazarTextoPlano(xml, datos, errors = [], runtimeContext = {}) {
  let resultado = ''
  let i = 0

  while (i < xml.length) {
    const start = xml.indexOf('${', i)
    if (start === -1) {
      resultado += xml.slice(i)
      break
    }

    resultado += xml.slice(i, start)
    const ph = extraerPlaceholder(xml, start)

    if (!ph) {
      // Placeholder sin cierre: copiar literal
      resultado += xml.slice(start, start + 2)
      i = start + 2
      continue
    }

    const contenido = ph.contenido.trim()
    const placeholderOriginal = consumirPlaceholderOriginal(runtimeContext, ph.tag)

    // 1️⃣ NO tocar imágenes
    if (contenido.startsWith('i:')) {
      resultado += ph.tag
      i = ph.endIndex
      continue
    }

    try {
      // 2️⃣ Variables normales v:
      if (contenido.startsWith('v:')) {
        const evaluado = evaluarPlaceholder(contenido, datos, errors, runtimeContext, ph.tag)
        resultado += evaluado.ok ? escaparXmlTexto(evaluado.value ?? '') : placeholderOriginal
        i = ph.endIndex
        continue
      }

      // 3️⃣ Funciones personalizadas
      if (/^[a-zA-Z0-9_]+:/.test(contenido)) {
        const evaluado = evaluarPlaceholder(contenido, datos, errors, runtimeContext, ph.tag)
        resultado += evaluado.ok ? escaparXmlTexto(evaluado.value ?? '') : placeholderOriginal
        i = ph.endIndex
        continue
      }

      // 4️⃣ Placeholder desconocido → dejarlo igual
      resultado += ph.tag
      i = ph.endIndex
    } catch (e) {
      errors.push({
        code: e?.code || 'placeholder_execution_error',
        message: e?.message || 'No se pudo evaluar el placeholder',
        detail: { tag: ph.tag, cause: e?.detail || String(e) },
      })
      resultado += ph.tag
      i = ph.endIndex
    }
  }

  return resultado
}
